// Actions
import {
  SET_APPLICANT,
  SET_APPLICANT_COMPLEX,
  SET_COMMUNITY_CENTER,
  SET_COMPANY,
  SET_CURRENT_USER,
  SET_PARENT,
  SET_STAFF,
  SET_SUPERVISOR,
  SET_USER_LOADING,
} from "../actions/actionTypes";

const initialState = {
  user: null,
  userLoading: false,
  company: null,
  companyLoading: false,
  applicant: null,
  applicantLoading: false,
  applicantComplex: null,
  applicantComplexLoading: false,
  loyacStaff: null,
  staffLoading: false,
  parent: null,
  parentLoading: false,
  supervisor: null,
  supervisorLoading: false,
  communitycenter: null,
  communitycenterLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_LOADING:
      return {
        ...state,

        userLoading: action.payload,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        userLoading: false,
      };
    case SET_STAFF:
      return {
        ...state,
        loyacStaff: action.payload,
        staffLoading: false,
      };
    case SET_SUPERVISOR:
      return {
        ...state,
        supervisor: action.payload,
        supervisorLoading: false,
      };
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
        companyLoading: false,
      };

    case SET_APPLICANT:
      return {
        ...state,
        applicant: action.payload,
        applicantLoading: false,
      };
    case SET_APPLICANT_COMPLEX:
      return {
        ...state,
        applicantComplex: action.payload,
        applicantComplexLoading: false,
      };
    case SET_COMMUNITY_CENTER:
      return {
        ...state,
        communitycenter: action.payload,
        communitycenterLoading: false,
      };
    case SET_PARENT:
      return {
        ...state,
        parent: action.payload,
        parentLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
